import appConfig from "@/config/app.config";
const { layouts } = appConfig;

/**
 * Routes meta
 */
const meta = {
  layout: layouts.auth,
  requiresAuth: false,
};

const publicRoutes = [
  {
    path: "/authentication",
    name: "authentication",
    meta,
    component: () =>
      import(
        /* webpackChunkName: "auth-issue" */ "@/views/Auth/Authentication.vue"
      ),
  },
];

export default publicRoutes;
